export default __webpack_public_path__ + "static/media/filter_icon_dining_area_blue.e7031b77.svg";